import { Button } from "@mui/material";
import { CloudDownload } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { TravelDocument } from "../../common/TravelDocument";
import { useDownloadTrainingTravelDocumentMutation, useDownloadTravelDocumentMutation } from "../../redux/api/travelDocument";

interface MyTravelDocumentsProps {
  orderId: number;
  training?: boolean;
  myTravelDocuments: TravelDocument[];
  parentCallback: Function;
}

const MyTravelDocuments = (props: MyTravelDocumentsProps) => {
  const [travelDocuments, setTravelDocuments] = useState<TravelDocument[]>();
  const [downloadTravelDocument] = useDownloadTravelDocumentMutation();
  const [downloadTrainingTravelDocument] = useDownloadTrainingTravelDocumentMutation();

  useEffect(() => {
    let res: any = JSON.parse(JSON.stringify(props.myTravelDocuments));
    setTravelDocuments(
      res.map((doc: any) => {
        // convert null values to empty string
        Object.keys(doc).forEach(
          (key) => (doc[key] = doc[key] === null ? "" : doc[key])
        );
        return doc as TravelDocument;
      })
    );
  }, [props.myTravelDocuments]);

  const handleDownload = async (url: string, fileName: string) => {
    const response = !!props.training ? 
      await downloadTrainingTravelDocument({
        trainingOrderId: props.orderId!.toString(),
        fileKey: url,
      }):
      await downloadTravelDocument({
        jobOrderId: props.orderId.toString(),
        fileKey: url,
      });
    if ("error" in response === false) {
      // create a temporary URL and link and simulate a click to trigger the browser download behavior
      // @ts-ignore - if there is no error object in the response, we know it must have a Blob 'data' attribute
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      props.parentCallback();
    }
  };

  return (
    <ul className="upload-list">
      {travelDocuments?.map((doc) => (
        <li key={doc.id} className="document-item">
          <span>{doc.displayName}</span>
            <div className="document-actions">  
              <Button
                onClick={() => handleDownload(doc.fileUrl, doc.displayName)}
                className="blue-link-button"
              >
                <CloudDownload />
                Download
              </Button>
            </div>
        </li>
      ))}
    </ul>
  );
}

export default MyTravelDocuments;
